module.exports = __webpack_public_path__ + "static/media/P2_S4_1.da914eeb.png";